import React, { useEffect, useMemo } from "react";
import styles from "./style.module.css";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import CustomTextField from "../../../../../../../components/FormFields/TextField/TextField.component";
import CustomCheckbox from "../../../../../../../components/FormFields/CustomCheckbox";
import { removeUnderScore } from "../../../../../../../helper/Helper";


const ShiftDetailsIncludeFields = ({
  index,
  changeData,
  data,
  errors,
  fieldLendth,
  setForm,
}) => {
  const theme = useTheme();

  const handleChange = (e, fieldName) => {
    const updates = { [fieldName]: e };
    if (["default_points", "extra_points"].includes(fieldName)) {
      if (e === '' || (e > 0 && e < 1000)) {
        changeData(index, updates);
      } 
    } 
    else if (fieldName === "is_checked") {
      if (!e) {
        setForm({
          is_checked: e,
        });
      }
      changeData(index, updates);
    } 
    else {
      changeData(index, updates);
    }
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.flexContainer}>
        <div className={styles.formWrp}>
          <div className={styles.formGrp21}>
            <CustomCheckbox
              color={"primary"}
              handleChange={() => {
                handleChange(!data?.is_checked, "is_checked");
              }}
              checked={data?.is_checked}
            />
          </div>
          <div className={styles.formGrphours}>
            <Typography variant="body1" color={theme.palette.text.primary}>
              {data?.name}
            </Typography>
          </div>
          <div className={styles.formGrphours}>
            <Typography variant="body1" color={theme.palette.text.primary}>
              {data?.type}
            </Typography>
          </div>
          <div className={styles.formGrphours}>
            <Typography variant="body1" color={theme.palette.text.primary}>
              {removeUnderScore(data?.action)}
            </Typography>
          </div>
          <div className={data?.is_checked ? styles.formGrphoursfield : styles.formGrphours}>
            {data?.is_checked ? (
              <CustomTextField
                type="number"
                label={"Default Points"}
                value={data?.default_points}
                onTextChange={(e) => handleChange(e, "default_points")}
                isError={errors?.default_points}
              />
            ) : (
              <Typography variant="body1" color={theme.palette.text.primary}>
                {data?.default_points || "-"}
              </Typography>
            )}
          </div>
          <div className={styles.formGrphoursfield}>
            {data?.is_extra_points && data?.is_checked ? (
              <CustomTextField
                label={"Extra Points"}
                value={data?.extra_points}
                onTextChange={(e) => handleChange(e, "extra_points")}
                isError={errors?.extra_points}
              />
            ) : (
              <Typography variant="body1" color={theme.palette.text.primary}>
                {data?.extra_points || "-"}
              </Typography>
            )}
          </div>
        </div>
      </div>
      {fieldLendth !== index + 1 && (
        <div className={styles.horizontalLine}></div>
      )}
    </div>
  );
};

export default ShiftDetailsIncludeFields;
